export const CHART_CONSTANTS = {
	HEIGHT: 400,
	COLORS: {
		PRIMARY_LINE: '#1e6fd2',
		AXIS_LABEL: '#607085'
	},
	LINE: {
		WIDTH: 2,
		MARKER_RADIUS: 4
	},
	LABELS: {
		DISPLAY_INTERVAL: 3,
		ROTATION: 0
	},
	SERIES: {
		NAME: 'Critical Issues Count',
		TYPE: 'line' as const
	}
} as const;

export const CHART_TEXT = {
	TITLE: 'Critical & serious issue trends',
	DESCRIPTION: 'This chart shows the trend of critical & serious accessibility issues.',
	NO_DATA_MESSAGE: 'No issues data available',
	TABLE_COLUMNS: {
		DATE: 'Date',
		CRITICAL: 'Critical',
		SERIOUS: 'Serious',
		TOTAL: 'Total'
	},
	TOOLTIP: {
		COUNT_LABEL: 'Issues:',
		DATE_LABEL: 'Date:'
	}
} as const;
